export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5043.e7c1d23c.jpg";